import {styled} from '@esgi/ui/theme';
import {DatePicker} from '@esgi/ui/controls';

export const DatePickerCalendarPanel = styled(DatePicker.CalendarPanel, {
	marginTop: 0,
	width: '100%',
});
